import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";
const SamsaraUsers = lazyLoader(
  () => import("Containers/SamsaraIntegration/SamsaraUsers/SamsaraUsers")
);

export const SamsaraUsersPage = () => {
  return (
    <Layout>
      <SamsaraUsers />
    </Layout>
  );
};
